import React, { useState } from 'react'
import realyIcon from "../../assets/icons/financialstatementIcons/cash 1.png"
import paidIcon from "../../assets/icons/financialstatementIcons/cash 1.png"
const PaidHooks = () => {
    const [search, setSearch] = useState(false)
  
  
    const NavItems = [
      { name: "Relay", to: "/financialstatement/relay", icon: realyIcon },
      { name: "Paid", to: "/financialstatement/paid", icon: paidIcon },
    ];

    const [selectedRange, setSelectedRange] = useState(null);
    const [dateToSend, setDateToSend] = useState({})

    const handleRangeChange = (range) => {
      setSelectedRange(range);
      setDateToSend({
        startDate: range.startDate, 
        endDate: range.endDate,
      })
    };

    
  
  
    return {
      NavItems,
      setSearch,
      handleRangeChange
    }
}

export default PaidHooks